import { ApolloClient, gql, TypedDocumentNode } from '@apollo/client'
import type {
  SetPositionPremiums,
  SetPositionPremiumsVariables
} from './__generated__/SetPositionPremiums'

const mutation: TypedDocumentNode<
  SetPositionPremiums,
  SetPositionPremiumsVariables
> = gql`
  mutation SetPositionPremiums($input: SetPositionPremiumsInput!) {
    setPositionPremiums(input: $input) {
      status
    }
  }
`

export function setPositionPremiumsMutation(
  apolloClient: ApolloClient,
  options: Omit<
    ApolloClient.MutateOptions<
      SetPositionPremiums,
      SetPositionPremiumsVariables
    >,
    'mutation'
  >
) {
  return apolloClient.mutate({
    mutation,
    ...options
  })
}
